/* Original name @uswitch/trustyle.sponsored-by-tag */
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import Imgix from 'react-imgix'
import { css } from '@emotion/react'

// lazysizes needed if you require lazyloading

const Image = ({ alt, critical, className = '', height, imgixParams, sizes, src, width }) => {
  if (!src) {
    return (
      <span
        className={className}
        css={css({
          display: 'inline-block',
          height,
          width,
        })}
      />
    )
  }
  return (
    <Imgix
      htmlAttributes={{ alt }}
      attributeConfig={
        !critical
          ? {
              src: 'data-src',
              srcSet: 'data-srcset',
              sizes: 'data-sizes',
            }
          : undefined
      }
      className={!critical ? `${className} lazyload` : className}
      src={src}
      height={height}
      width={width}
      sizes={sizes}
      imgixParams={imgixParams}
    />
  )
}

const ImgixImage = React.memo(Image)

const lookup = (variant) =>
  variant === 'base'
    ? 'elements.sponsored-by-tag.base'
    : `elements.sponsored-by-tag.variants.${variant}`

const SponsoredByTag = ({
  providerLogoSrc,
  className = '',
  providerText = 'Sponsored by',
  providerName,
  variant = 'base',
}) => (
  <div
    className={className}
    sx={{
      display: 'flex',
      alignItems: 'center',
      variant: `${lookup(variant)}.wrapper`,
    }}
  >
    <span
      sx={{
        variant: `${lookup(variant)}.text`,
      }}
    >
      {providerText}
    </span>

    <ImgixImage
      src={providerLogoSrc}
      alt={providerName}
      imgixParams={{
        fit: 'fill',
        h: 45,
        bg: '00FFFFFF', // weirdly, fixes size issues
      }}
      critical
      height={46}
      sx={{
        variant: `${lookup(variant)}.image`,
      }}
    />
  </div>
)

export default SponsoredByTag
